module.exports = __webpack_public_path__ + "static/media/Vendas5.e55208d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas5.png
// module id = 1776
// module chunks = 0